import { useEffect, useState } from 'react'

import { DataService } from 'api/DataService'
import { useAuthContext } from 'context/AuthContext'
import { setCookie } from 'nookies'

/**
 * Hook para verificar se a conta Cora está conectada
 * Só faz a verificação se o plano for basic_cora ou cora_enabled
 */
export const useCoraAccountCheck = () => {
  const { user, setUser } = useAuthContext()
  const [isChecking, setIsChecking] = useState(false)
  const [hasCoraAccount, setHasCoraAccount] = useState<boolean | undefined>(
    user?.cora_bank
  )

  useEffect(() => {
    const checkCoraAccount = async () => {
      // Só verifica se:
      // 1. O usuário existe
      // 2. O plano é basic_cora ou cora_enabled
      // 3. Ainda não verificamos (cora_bank é undefined ou false)
      if (
        !user ||
        (user.current_plan !== 'basic_cora' && !user.cora_enabled) ||
        isChecking ||
        user.cora_bank === true
      ) {
        return
      }

      setIsChecking(true)

      try {
        const response = await DataService({
          url: '/v1/merchants/corabank_account',
          type: 'GET'
        })

        // Contrato do back: connected === true apenas quando a conexão Cora
        // está ativa. Conexão expirada (needs_reconnect) retorna connected:
        // false, mantendo o banner de "Configure sua conta Cora" para o
        // merchant reconectar.
        const isConnected = !response.error && response.data?.connected === true

        setHasCoraAccount(isConnected)

        // Atualiza o cookie e o contexto
        setCookie(undefined, 'nextauth.cora_bank', String(isConnected), {
          maxAge: 60 * 60 * 24 * 6
        })

        if (user) {
          setUser({
            ...user,
            cora_bank: isConnected
          })
        }
      } catch (error) {
        console.error('Erro ao verificar conta Cora:', error)
        // Em caso de erro, assume que não está conectado
        setHasCoraAccount(false)
      } finally {
        setIsChecking(false)
      }
    }

    checkCoraAccount()
  }, [user?.uuid, user?.current_plan, user?.cora_enabled]) // Só executa quando o usuário mudar

  return {
    hasCoraAccount,
    isChecking
  }
}
